import { render, staticRenderFns } from "./ExerciseDemoList.vue?vue&type=template&id=0177830c"
import script from "./ExerciseDemoList.vue?vue&type=script&lang=js"
export * from "./ExerciseDemoList.vue?vue&type=script&lang=js"
import style0 from "./ExerciseDemoList.vue?vue&type=style&index=0&id=0177830c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports